import { render, staticRenderFns } from "./Knowledge.vue?vue&type=template&id=1e302166&scoped=true&lang=html&"
import script from "./Knowledge.vue?vue&type=script&lang=js&"
export * from "./Knowledge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e302166",
  null
  
)

export default component.exports